import { render, staticRenderFns } from "./StackedAreaScoreController.vue?vue&type=template&id=9b4368ee&"
import script from "./StackedAreaScoreController.vue?vue&type=script&lang=ts&"
export * from "./StackedAreaScoreController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports